import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { RestfulService } from 'src-ironside/services/restful.service';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

export type Country = {
    id: string;
    title: string;
    value: string;
};

@Injectable()
export class CountryRepository extends RestfulService {
    constructor(public override httpClient: HttpClient, public override router: Router) {
        super(httpClient, router);
    }
    find(page = 1, pageSize = 150): Observable<Country[]> {
        return this.doGet(`parametre/nomtable/COUNTRY`).pipe(
            map((res) =>
                res
                    .map((country: any) => ({
                        id: country.id,
                        title: country.mapLocalLibelle,
                        value: country.valeur,
                    }))
                    .sort((a: Country, b: Country) => a.value.localeCompare(b.value))
            )
        );
    }
}
